var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import Icon, { FocusableIcon } from "./Icon";
import { getText, getAllText } from "../translations";
import get from "lodash/get";
export var phrasingHasFocusableElements = function (phrasingItems) {
    return (Array.isArray(phrasingItems) &&
        phrasingItems.findIndex(function (phrasingItem) {
            return phrasingItem && phrasingItem.hasOwnProperty("tooltip");
        }) >= 0);
};
export var getAllPhrasingTextContent = function (phrasingItems) {
    return Array.isArray(phrasingItems)
        ? phrasingItems.reduce(function (acc, phrasingItem) {
            if (!phrasingItem)
                return acc;
            if (get(phrasingItem, "icon"))
                return acc;
            return acc + getAllText(phrasingItem);
        }, "")
        : getAllText(phrasingItems);
};
export var getPhrasingTextContent = function (locale, phrasingItems) {
    return Array.isArray(phrasingItems)
        ? phrasingItems.reduce(function (acc, phrasingItem) {
            if (!phrasingItem)
                return acc;
            if (get(phrasingItem, "icon"))
                return acc;
            return acc + getText(locale, phrasingItem);
        }, "")
        : getText(locale, phrasingItems);
};
var defaultIconStyles = function (truncate) { return (__assign({}, (truncate ? { flex: "0 0 auto" } : { transform: "translateY(-0.1em)" }))); };
var defaultTextStyles = function (truncate, textSelectable) { return (__assign(__assign({}, (truncate && {
    flex: "0 1 auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
})), (textSelectable && { pointerEvents: "all", cursor: "text" }))); };
var PhrasingGroup = function (_a) {
    var phrasingItems = _a.content, locale = _a.locale, iconStyles = _a.iconStyles, _b = _a.truncate, truncate = _b === void 0 ? false : _b, _c = _a.textSelectable, textSelectable = _c === void 0 ? false : _c;
    var phrasingElements = Array.isArray(phrasingItems) ? (phrasingItems.map(function (phrasingItem, i) {
        var styles = i === 0 ? {} : { marginLeft: ".5rem" };
        if (!phrasingItem)
            return null;
        if (get(phrasingItem, "icon")) {
            var finalStyles = __assign(__assign(__assign({}, defaultIconStyles(truncate)), iconStyles), styles);
            if (phrasingItem.hasOwnProperty("tooltip")) {
                return (React.createElement(FocusableIcon, __assign({}, phrasingItem, { locale: locale, styles: finalStyles })));
            }
            else {
                return (React.createElement(Icon, __assign({}, phrasingItem, { styles: finalStyles })));
            }
        }
        else {
            return (React.createElement(Text, __assign({}, {
                content: getText(locale, phrasingItem),
                styles: __assign(__assign({}, defaultTextStyles(truncate, textSelectable)), styles),
            })));
        }
    })) : (React.createElement(Text, __assign({}, {
        content: getText(locale, phrasingItems),
        styles: defaultTextStyles(truncate, textSelectable),
    })));
    return truncate ? (React.createElement(Flex, { vAlign: "center", wrap: false, children: phrasingElements, styles: { whiteSpace: "nowrap" } })) : (React.createElement(React.Fragment, { children: phrasingElements }));
};
export default PhrasingGroup;
//# sourceMappingURL=Phrasing.js.map